import { render, staticRenderFns } from "./productionDeclare.vue?vue&type=template&id=3a1a4a7c&scoped=true&"
import script from "./productionDeclare.vue?vue&type=script&lang=js&"
export * from "./productionDeclare.vue?vue&type=script&lang=js&"
import style0 from "./productionDeclare.vue?vue&type=style&index=0&id=3a1a4a7c&scoped=true&lang=css&"
import style1 from "./productionDeclare.vue?vue&type=style&index=1&lang=css&"
import style2 from "./productionDeclare.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1a4a7c",
  null
  
)

export default component.exports